const initial = {
  productDetails: '',
  similarData: '',
  ensamble: '',
  capsules: '',
  recentlyViewed: '',
  selectedSizeCode: '',
  selectedSizeName: '',
  selectedSizeStockLevel: '',
  discountPrice: '',
  originalPrice: '',
  discountPercentage: '',
  pincode: '',
  selectedImageId: 0,
  sizeData: '',
  crossSellData:'',
  productListsOffset:''
};

// reducers
export default function product(state = initial, action) {
  switch (action.type) {
    case 'FETCH_SIZE_DATA':
      return {
        ...state,
        sizeData: action.sizeData
      };
    case 'FETCH_SIZE_RECOMMEND':
      return {
        ...state,
        sizeRecommendData: action.sizeRecommendData
      };

    case 'FETCH_SIZE_RECOMMEND_POP_UP':
      return {
        ...state,
        sizeRecommendPopUpData: action.sizeRecommendPopUpData
      };

    case 'FETCH_PRODUCT_DATA':
      const { fnlColorVariantData: { sizeGuideDesktop = '{}' } = {} } = action.product;
      return {
        ...state,
        sizeData: JSON.parse(sizeGuideDesktop),
        productDetails: action.product
      };

    case 'FETCH_BANK_COUPONS':
      const { allBankOffer = [] } = action.couponsData;
      return {
        ...state,
        bankOffers: allBankOffer
      };

    case 'YOU_MAY_ALSO_LIKE':
      return {
        ...state,
        reqObj: action.obj
      };

    case 'FETCH_SIMILAR_DATA':
      return {
        ...state,
        similarData: action.similarData
      };

      case 'FETCH_CROSS_SELL_DATA':
        return {
          ...state,
          crossSellData: action.crossSellData
        };

    case 'FETCH_CAPSULES_DATA':
      return {
        ...state,
        capsules: action.capsules
      };

    case 'FETCH_ENSAMBLE_DATA':
      return {
        ...state,
        ensamble: action.ensamble
      };

    case 'FETCH_RECENT_DATA':
      return {
        ...state,
        recentlyViewed: action.recentlyViewed
      };

    case 'SET_PINCODE':
      return {
        ...state,
        pincode: action.pincode
      };

    case 'EMPTY_PRODUCT_DETAILS':
      return {
        ...state,
        productDetails: '',
        sizeData: ''
      };

    case 'SELECT_SIZE':
      let { discountPrice, originalPrice, cartOrNot = '' } = action;
      let sp = '';
      let cp = '';
      if (discountPrice) {
        sp = parseInt(discountPrice.replace(/\D/g, ''));
        cp = parseInt(originalPrice.replace(/\D/g, ''));
      }
      let discountPercent;
      let discount;
      if (sp !== cp) {
        discountPercent = Math.round(((cp - sp) / cp) * 100);
        discount = `${discountPercent}% off`;
      }
      return {
        ...state,
        selectedSizeName: action.selectedSizeName,
        selectedSizeCode: action.selectedSizeCode,
        selectedSizeStockLevel: action.selectedSizeStockLevel,
        discountPrice: action.discountPrice,
        originalPrice: action.originalPrice,
        discountPercentage: discount,
        cartOrNot
      };

    case 'SELECT_BY_ID':
      return {
        ...state,
        selectedImageId: action.payload
      };

    case 'RESET_IMAGE_SELECTED':
      return {
        ...state,
        selectedImageId: 0
      };

    case 'DOD_SIZE_CHANGE':
      return {
        ...state,
        dodSize: action.dodSize
      };
    case 'PREVIOUS_SEARCH_SOURCE':
      return {
        ...state,
        previousSource: action.values
      };
    case 'SET_PAGE_CATEGORY':
      return {
        ...state,
        pageCategory: action.values
      };
      case "PREVIOUS_PRODUCT_OFFSET":
        return {
          ...state,
          productListsOffset: action.data,
        };      
    default:
      return state;
  }
}
